export default "__VITE_ASSET__523784f5__"